import { render, staticRenderFns } from "./addCommunitySpacePerson.vue?vue&type=template&id=79b8194a"
import script from "./addCommunitySpacePerson.vue?vue&type=script&lang=js"
export * from "./addCommunitySpacePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports